import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { jiraApiURL, jiraUserApiURL, baseAPI } from 'src/app/services/apiRoutes';

@Injectable()
export class JiraUserService {
  constructor(public http: HttpClient) {}

  getJiraUsers(query: string) {
    return this.http.get(jiraUserApiURL + '/?query=' + query).toPromise();
  }

  createUser(userId: string, groups) {
    return this.http.post(jiraApiURL + '/?uid=' + userId, groups).toPromise();
  }

  getUserGroupMembership() {
    return this.http.get(baseAPI + '/user/group/membership').toPromise();
  }

}
